import { cn } from '@april9au/react-common/utils';

import logoUrl from '@/assets/logos/logo.png';

import type { NavLink } from './site-header';

const DEFAULT_LINKS: Array<NavLink> = [
  { label: 'Our Story', to: '/#our-story' },
  { label: 'Selling', to: '/selling' },
  { label: 'Insights', to: '/#insights' },
  { label: 'FAQs', to: '/faq' },
];

/** Site-wide footer. Renders once in the root layout so it's shared across every page. */
export function SiteFooter({
  tagline,
  location,
  copyright,
  links = DEFAULT_LINKS,
  className,
}: {
  tagline: string;
  location: string;
  copyright: string;
  links?: Array<NavLink>;
  className?: string;
}) {
  return (
    <footer className={cn('footer', className)}>
      <div className="container flex flex-col gap-8">
        <div className="flex flex-col items-center justify-between gap-6 md:flex-row md:items-start">
          <div className="footer__brand items-center md:items-start">
            <img src={logoUrl} alt="Meet Real Estate" className="h-12 w-auto" />
            <span className="text-brand-name">Meet Real Estate</span>
            <span className="footer__tagline">
              {tagline} · {location}
            </span>
          </div>

          {links.length ? (
            <nav className="flex flex-wrap justify-center gap-x-6 gap-y-2 md:justify-end">
              {links.map((link) => (
                <a key={link.to} href={link.to} className="nav__link">
                  {link.label}
                </a>
              ))}
            </nav>
          ) : null}
        </div>

        <p className="footer__legal text-center md:text-left">{copyright}</p>
      </div>
    </footer>
  );
}
